import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@rekruto/core';
import { CompanyContextService } from './company-context';

/**
 * Company-app route guards. The core `authGuard` only checks that a session exists; these add the
 * tenant dimension so a signed-in user with no company seat is sent to onboarding instead of an
 * empty dashboard, and a signed-in user never sees the signup/login screens again.
 */

/** Signed-out visitors only: a signed-in user is sent on to their landing. */
export const signedOutGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const company = inject(CompanyContextService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) return true;
  return router.createUrlTree([company.companyId() ? '/overblik' : '/onboarding']);
};

/** A seat is required for the whole routed shell; seatless users go to onboarding. */
export const companySeatGuard: CanActivateFn = () => {
  const company = inject(CompanyContextService);
  const router = inject(Router);

  return company.companyId() ? true : router.createUrlTree(['/onboarding']);
};

/** Onboarding is for a seatless signed-in user only; a seated user is sent to the dashboard. */
export const noSeatGuard: CanActivateFn = () => {
  const company = inject(CompanyContextService);
  const router = inject(Router);

  return company.companyId() ? router.createUrlTree(['/overblik']) : true;
};
